const element = document.querySelector('.image-compare');

if (element) {
    const viewer = new ImageCompare(element, {
        smoothing: true,
        hoverStart: true,
        addCircle: true,
        addCircleBlur: false,
    }).mount();
}